export default __webpack_public_path__ + "static/media/Department_for_Digital_Culture_Media_Sport.6eb39bdb.svg";